export const PARAMS_IMPORT_STEPS = {
  UPLOAD: "upload",
  MAPPING: "mapping",
  VALIDATION: "validation",
  VALUE_MAPPING: "value_mapping",
  ANALYSIS: "analysis",
  IMPORTING: "importing",
  RESULT: "result",
};

export const ACCEPTED_FILE_EXTENSIONS = [".xls", ".xlsx", ".csv"];
export const FILE_ACCEPT_STRING = ".xls,.xlsx,.csv";

export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const CSV_TEMPLATE_HEADERS = [
  "Identifiant *",
  "Âge minimum",
  "Âge maximum",
  "Date d'effet (jours)",
  "Date d'effet max (jours)",
  "Date d'effet RIA (jours)",
  "Date d'effet max RIA (jours)",
  "Rétroactivité",
  "Cadre d'exercice",
  "Régimes sociaux",
  "Profession",
  "Profils",
  "Sous-profils",
  "Départements",
  "Codes postaux",
  "IDCC (codes)",
  "Communes",
  "Parcours",
  "Devis",
  "Devoir de conseil (DDA)",
  "Bulletin d'adhésion",
  "Mandat SEPA",
  "Lettre de résiliation",
  "Mandat de résiliation",
];

export const CSV_TEMPLATE_EXAMPLE_ROW = [];

export const resolveError = (err, errorKeys) => {
  if (typeof err === "string") return err;
  if (!err || !err.key) return String(err);
  const template = errorKeys?.[err.key];
  if (!template) return err.key;
  const resolved = Object.entries(err.params || {}).reduce(
    (msg, [k, v]) => msg.replaceAll(`{{${k}}}`, v ?? ""),
    template,
  );
  return resolved.replace(/\s*\{\{[^}]+\}\}/g, "").trim();
};
